import {GUEST_FORM_NAMES} from '@chekin/core';

export const FIELD_SUBGROUP = {
  nationality: 'nationality',
  legal_name: 'legal_name',
} as const;

export const FIELD_NAME_SUBGROUP: Record<string, string> = {
  [GUEST_FORM_NAMES.nationality]: FIELD_SUBGROUP.nationality,
  [GUEST_FORM_NAMES.name]: FIELD_SUBGROUP.legal_name,
  [GUEST_FORM_NAMES.surname]: FIELD_SUBGROUP.legal_name,
  [GUEST_FORM_NAMES.second_surname]: FIELD_SUBGROUP.legal_name,
};
